import { useState, useCallback } from "react";
import HeaderBar from "../Components/HeaderBar";
import Footer from "../Components/Footer";
import SeasonsSelector from "../Components/SeasonsSelector";
import SelectHoll from "../Components/SelectHoll";
import SelectFelag from "../Components/SelectFelag";
import FullScreenLoader from "../Components/FullScreenLoader";
import Kolofon from "../Components/Kolofon";

export default function Heim() {
  // Track concurrent async operations from child components
  const [pending, setPending] = useState(0);
  const loading = pending > 0;

  // Stable setter: increments on true, decrements on false
  const setLoadingState = useCallback((isLoading) => {
    setPending((p) => (isLoading ? p + 1 : Math.max(0, p - 1)));
  }, []);

  return (
    <>
      <HeaderBar />
      <SeasonsSelector setLoadingState={setLoadingState} />
      <SelectHoll setLoadingState={setLoadingState} />
      <SelectFelag setLoadingState={setLoadingState} />
      <Footer />
      <Kolofon />
      {loading && <FullScreenLoader />}
    </>
  );
}
